import { Row } from "antd";
import { Route, Switch } from "react-router-dom";
import NavMenu from "./NavMenu/NavMenu";
import EditProfile from "./EditProfile/EditProfile";
import MyLog from "./MyLog/MyLog";
import Notifications from "./Notifications/Notifications";
import MyFavorites from "./MyFavorites/MyFavorites";

const StudentProfilePage = () => {
  return (
    <>
      <br />

      <br />
      <Row align="middle" style={{ paddingLeft: "5%", paddingRight: "5%" }}>
        <Switch>
          <Route path="/student-profile/my-favourites/" component={MyFavorites} />
          <Route path="/student-profile/notifications/" component={Notifications} />
          <Route path="/student-profile/my-log/" component={MyLog} />
          <Route path="/student-profile/edit-profile/" component={EditProfile} />
          <Route path="/student-profile/" component={NavMenu} />
        </Switch>
      </Row>
      <br />
    </>
  );
};

export default StudentProfilePage;
